(function () {
  function init(root) {
    if (!root || root.dataset.qbpReady) return;
    root.dataset.qbpReady = '1';
    var slides = root.querySelectorAll('.qbp-slide');
    var dots = root.querySelectorAll('.qbp-dot');
    if (slides.length < 2) return;
    var i = 0, timer = null, paused = false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = parseInt(root.dataset.interval, 10) || 5000;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        if (on) { var img = s.querySelector('img[loading="lazy"]'); if (img) img.loading = 'eager'; }
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      var nxt = slides[(i + 1) % slides.length].querySelector('img[loading="lazy"]');
      if (nxt) nxt.loading = 'eager';
    }
    function stop() { clearInterval(timer); timer = null; }
    function start() { stop(); if (!reduce && !paused && !document.hidden) timer = setInterval(function () { go(i + 1); }, interval); }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.index, 10)); start(); }); });
    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { paused = false; start(); } });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(i + 1); } else if (e.key === 'ArrowLeft') { go(i - 1); }
    });
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1));
      x0 = null; start();
    }, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  }
  function all() { document.querySelectorAll('[data-qbp-carousel]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-qbp-carousel]'); if (!root) return;
    var slides = Array.prototype.indexOf.call(root.querySelectorAll('.qbp-slide'), e.target);
    var dot = root.querySelectorAll('.qbp-dot')[slides]; if (dot) dot.click();
    root.dispatchEvent(new Event('mouseenter'));
  });
})();
